function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgQuotesDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40.29 35.17"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M658.72 1388.3a16.25 16.25 0 0 1-2-8 20.29 20.29 0 0 1 5-13.76 32.4 32.4 0 0 1 12-8.73l1.89 3.24v.9a12.9 12.9 0 0 0-4.72 3.15 18.56 18.56 0 0 0-3.87 5.58 15.56 15.56 0 0 0-1.49 6.56 9.6 9.6 0 0 0 1.4 5.26 5.29 5.29 0 0 0 3.82 2.57l-.27 1.62-5.76 6.29a9.37 9.37 0 0 1-6-4.68Zm21.4 0a16.25 16.25 0 0 1-2-8 20.29 20.29 0 0 1 5-13.76 32.45 32.45 0 0 1 12-8.73L697 1361v.9a13 13 0 0 0-4.72 3.15 18.56 18.56 0 0 0-3.87 5.58 15.54 15.54 0 0 0-1.48 6.56 9.6 9.6 0 0 0 1.39 5.26 5.31 5.31 0 0 0 3.83 2.57l-.27 1.62-5.76 6.29a9.37 9.37 0 0 1-6-4.63Z",
  transform: "translate(-656.74 -1357.76)",
  style: {
    fill: "#3cc"
  }
}));

export default SvgQuotesDown;